import { render, staticRenderFns } from "./FileImportLicensingTable.vue?vue&type=template&id=bfb3e850&scoped=true&"
import script from "./FileImportLicensingTable.vue?vue&type=script&lang=js&"
export * from "./FileImportLicensingTable.vue?vue&type=script&lang=js&"
import style0 from "./FileImportLicensingTable.vue?vue&type=style&index=0&id=bfb3e850&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb3e850",
  null
  
)

export default component.exports